export const stepCounter_en = {
  'step_settings' : 'Step counter settings',
  'stepcounter': 'Step counter',
  'stepcounter_access_info': 'To track your steps you must activate the step counter.',
  'stepcounter_is' : 'The step counter is ',
  'active': 'on',
  'not_active': 'off',
  'stepcounter_onoff': 'Turn step counter on/off',
  'add_daily_goal' : 'Set a daily goal',
  'daily_goal': 'Daily goal:',
  'change_daily_goal' : 'Change daily goal',
  'active_info' : 'Activate the step counter to begin tracking your steps in the app.',
  'updated' : 'Updated',
  'reached_goals' : 'Goals reached',
  'steps' : 'Steps',

  'steps_per_h': 'Steps per hour',
  'hour' : 'Hour',
  'stepsday' : 'Steps/Day',
  'chosen_value': 'Chosen value:',
  
  'active_challenge' : 'Active challenge',
  'no_active_challenge' : 'No active challenge at the moment',
  'distance_done' : 'Distance done',
  'route' : 'Route',
  'active_persons' : 'Active members',
  'total_steps' : 'Total steps:',
  'total_walks' : 'Total walks:',
  'booked_walks' : 'Booked walks:',
  'created_walks' : 'Created walks:',

  'stepcounter_enabled' : 'Step-counter enabled',
  'stepcounter_disabled' : 'Step-counter disabled',
  'goal' : 'Goal',
  'view_steps' : 'View step-data',
  'activate_steps' : 'Activate stepcounter',
  'leaderboard' : 'Leaderboard',
  'leaderboard_info' : 'Compete in weekly step-challenges with your team',
  'all_challenges' : 'All challenges',
  'view_challenge_history' : 'View challenge-history',

  'activity_challenges' : 'Activity challenges',
  'no_challenge' : 'No challenges found',
  'handle_stepcounter' : 'Manage step-counter',

  'open_settings' : 'Open settings',
  'not_available' : 'Not available',

  'get_started_steps' : 'Kom igång och räkna dina steg',
  'allow_permission' : 'Allow permission',
  'step_one_steps' : 'Open the apps settings, go to "Permissions" and allow the app access to "Physical activity".',
  'reload_app' : 'Reload the app',
  'reload_app_info' :'Reload the app or press the button below to get started.',
  'step_only_app' : 'You can only give permission and use the stepcounter from the app, not webb',
  'manage_stepcounter' : 'Manage stepcounter',

  'personal_activity' : 'Personal activity',
  'daily_step_average' : 'Daily average:',
  'distance_left' : 'Distance left:',
  'more_stats' : 'More statistics',
  'details' : 'Details',
  'activity_challenge' : 'Activity challenge',
  'days_left' : 'Days left:',
  'could_not_load': 'Could not load challenge',
  'steps_done' : 'You have done ',
  'steps_percentage' : ' % of the step-goal',

  'my_orgs' : 'Show only my organisation',
  'team_average' : 'Team average',
  'week_average' : 'Weekly average:',
  'week_team_average' : 'Weekly team average',
  'week_total_step' : 'Weekly total steps',





}
